/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Box, Container, IconButton, makeStyles } from "@material-ui/core";
import {
  FilterButton,
  HeaderWithButtons,
  Searchbar,
} from "../components-molecules";
import CssBaseline from "@material-ui/core/CssBaseline";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { InvoiceButtonSection } from "../components-molecules/InvoiceButtonSection";
import { InvoiceGroupItem } from "../components-molecules/InvoiceGroupItem";
import { useDispatch, useSelector } from "react-redux";
import { getShopInvoices } from "../redux/actions/shopInvoices";
import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import multiDownload from "multi-download";
import { debounce } from "lodash";
import moment from "moment";
import { NoResultsFound } from "../components-molecules/NoResultsFound";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
import { GetTemporaryInvoiceUrl } from "../service/temporary-access-service";
import { theme } from "../constants/theme";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
export type OrderSortType = "asc" | "desc";
const debounceDuration = 500;
const pageSize = 10;
const defaultPage = 0;

const Invoices = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [InvoiceData, setInvoiceData] = useState<any>([]);
  const [downloadButtonDisabled, setDownloadButtonDisabled] = useState(true);
  const shopInvoicesData = useSelector((state: any) => state.shopInvoices.data);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filter, setFilter] = useState({
    Date: [],
  });
  const [filterApplied, setFilterApplied] = useState(filtersApplied(filter));
  const shopInvoicesLoading = useSelector(
    (state: any) => state.shopInvoices.loading
  );

  useEffect(() => {
    dispatch(getShopInvoices(defaultPage, pageSize, null, null, null, null, null, null));
  }, []);
  useEffect(() => {
    if (shopInvoicesData !== null && shopInvoicesData.invoiceGroups) {
      const newInvoiceData = shopInvoicesData.invoiceGroups.map((element) => {
        const newInvoice = element.Invoices.map((item) => {
          return { ...item, isChecked: false };
        });
        return { ...element, Invoices: newInvoice };
      });

      setInvoiceData(newInvoiceData);
    }
  }, [shopInvoicesData]);
  const loadMore = () => {
    dispatch(getShopInvoices(shopInvoicesData.page + 1, pageSize, null, null, null, null, null, null));
  };
  useEffect(() => {
    const query = searchQuery !== "" ? searchQuery : null;
    dispatch(getShopInvoices(defaultPage, pageSize, null, null, null, null, query, null));
  }, [searchQuery]);

  useEffect(() => {
    const result = filtersApplied(filter);
    setFilterApplied(result);
  }, [filter]);

  const filterOnSubmit = (filter) => {
    if (filter && (!filter.Date || filter?.Date.length === 0) && (!filter.InvoiceType || filter?.InvoiceType.length === 0)) {
      dispatch(getShopInvoices(defaultPage, pageSize, null, null, null, null, null, null));
      return;
    }

    const formatedStartDate = filter.Date[0]
      ? moment(filter.Date[0]).format("YYYY-MM-DD")
      : null;
    const formatedEndDate = filter.Date[1]
      ? moment(filter.Date[1]).format("YYYY-MM-DD")
      : null;
    setFilter(filter);
    dispatch(
      getShopInvoices(defaultPage, pageSize, formatedStartDate, formatedEndDate, null, null, null, {
        TradeKartCollect: filter.InvoiceType?.includes("tradekartcollect"),
        Shop: filter.InvoiceType?.includes("shop"),
      })
    );
  };

  const onCheckboxChange = (data, value) => {
    let disableShowButton = true;
    if (value) {
      disableShowButton = false;
    } else {
      disableShowButton = true;
    }

    const newInvoiceData: any = InvoiceData.map((element: any) => {
      const newInvoice = element?.Invoices.map((item) => {
        if (item.InvoiceNo === data.InvoiceNo) {
          return { ...item, isChecked: value };
        } else {
          return item;
        }
      });
      return { ...element, Invoices: newInvoice };
    });
    setInvoiceData(newInvoiceData);
    newInvoiceData.forEach((element, index) => {
      element.Invoices.forEach((item) => {
        if (item.isChecked) {
          disableShowButton = false;
        }
      });
    });
    setDownloadButtonDisabled(disableShowButton);
  };

  const downloadPdfs = async () => {
    const selectedInvoices: Array<string> = [];
    InvoiceData.forEach((element: any) => {
      const newInvoice = element?.Invoices.forEach((item: any) => {
        if (item.isChecked) {
          selectedInvoices.push(item);
        }
      });
      return { ...element, Invoices: newInvoice };
    });
    let blobs: Array<any> = [];
    let invoiceNames: Array<String> = [];
    selectedInvoices.forEach((item: any, index: number) => {
      GetTemporaryInvoiceUrl(item.InvoiceNo, async (result) => {
        const data = await fetch(result, {
          method: "GET",
          mode: "cors",
          headers: { Accept: "form-data" },
        });

        const convertedToBlob = await data.blob();
        const convertedToUrl = await window.URL.createObjectURL(
          new Blob([convertedToBlob])
        );
        blobs.push(convertedToUrl);
        invoiceNames.push(item.InvoiceNo);
        if (selectedInvoices.length - 1 === index) {
          multiDownload(blobs, {
            rename: ({ url, index, urls }) => invoiceNames[index] + ".pdf",
          });
        }
      });
    });
  };

  const selectAllClicked = () => {
    const newInvoiceData: any = InvoiceData.map((element: any) => {
      const newInvoice = element?.Invoices.map((item) => {
        return { ...item, isChecked: true };
      });
      return { ...element, Invoices: newInvoice };
    });
    setDownloadButtonDisabled(false);
    setInvoiceData(newInvoiceData);
  };
  const clearAllClicked = () => {
    const newInvoiceData: any = InvoiceData.map((element: any) => {
      const newInvoice = element?.Invoices.map((item) => {
        return { ...item, isChecked: false };
      });
      return { ...element, Invoices: newInvoice };
    });
    setDownloadButtonDisabled(true);
    setInvoiceData(newInvoiceData);
  };

  if (!InvoiceData) {
    return null;
  }

  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons title={t('invoices.title')}>
          <HeaderWithButtons.ButtonArea>
            <>
              <FilterButton
                searchableList={["Shop"]}
                dateKey="Date"
                singleDate
                defaultOption={"Date"}
                data-automation="filter-button"
                onSubmit={filterOnSubmit}
                inButtonSet
                options={{
                  Date: [
                    { title: "From", value: "" },
                    { title: "To", value: "" },
                  ],
                  InvoiceType: [
                    { title: "TradeKart Collect Only", value: "tradekartcollect" },
                    { title: "Shop Only", value: "shop" },
                  ],
                }}
                filter={{
                  Date: [],
                }}
              />
              <IconButton
                data-automation="search-button"
                className={classes.searchButton}
                color="primary"
                onClick={() =>
                  searchOpen ? setSearchOpen(false) : setSearchOpen(true)
                }
              >
                <SearchRoundedIcon
                  color="primary"
                  className={classes.searchIcon}
                />
              </IconButton>
            </>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        <Searchbar
          query={searchQuery}
          isOpen={searchOpen}
          placeholder="Search Invoices"
          onCancel={() => {
            setSearchOpen(false);
            setSearchQuery("");
          }}
          onChange={(event) => {
            debounce(
              (e) => setSearchQuery(e.target.value),
              debounceDuration
            )(event);
          }}
        />
        {shopInvoicesLoading && InvoiceData.length <= pageSize ? (
          <CircularProggressIndicator />
        ) : (
          <div className={classes.contentContainer}>
            {shopInvoicesData.length !== 0 ? (
              <InvoiceButtonSection
                downloadClicked={downloadPdfs}
                downloadDisabled={downloadButtonDisabled}
                selectAllClicked={selectAllClicked}
                clearAllClicked={clearAllClicked}
                clearAllDisabled={downloadButtonDisabled}
              />
            ) : null}
            <div className={classes.invoiceSection}>
              {InvoiceData && InvoiceData.length !== 0 ? (
                <InfiniteScroll
                  style={{ overflow: "hidden" }}
                  dataLength={InvoiceData.map((m) => m.Invoices).flat().length} // This is important field to render the next data
                  next={() => loadMore()}
                  scrollThreshold={0.8}
                  hasMore={
                    InvoiceData.map((m) => m.Invoices).flat().length !== shopInvoicesData.total
                  }
                  loader={<CircularProggressIndicator />}
                >
                  {InvoiceData.map((groupItem) => {
                    return (
                      <InvoiceGroupItem
                        key={groupItem.OrderNo}
                        data={groupItem}
                        onCheckboxChange={onCheckboxChange}
                      />
                    )
                  })}
                </InfiniteScroll>
              ) : (
                <NoResultsFound
                  query={searchQuery}
                  filterApplied={filterApplied}
                />
              )}
            </div>
          </div>
        )}
      </Container>
    </Box>

  );
};

const filtersApplied = (filter: any) => {
  let applied = false;

  Object.values(filter).forEach((x: any) => {
    if (x.length > 0) {
      applied = true;
    }
  });
  return applied;
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    flexGrow: 1,
    maxWidth: 840,
    paddingLeft: 0,
    paddingRight: 0,
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    marginRight: 24,
    alignSelf: "center",
    ...buttonHoverAndActive
  },
  contentContainer: {
    //
  },
  invoiceSection: {
    //
  },

  textButton: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.secondary[24],
    },
  },
  printButtonText: {
    textTransform: "none",
  },
  noSearchResults: {
    display: "flex",
    paddingLeft: 24,
    paddingTop: 40,
    flexDirection: "column",
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
    paddingTop: "96px",
  },
});
export default Invoices;
